module.exports = __webpack_public_path__ + "img/pd-img26.9708adb0.png";